import { Expose } from "class-transformer";
import { IsString } from "class-validator";

export class EmailAddressHint {
  @IsString()
  @Expose()
  emailAddress!: string;
}
